export const metaConnectorProvider = 'META' as const;
export const gupshupConnectorProvider = 'GUPSHUP' as const;
export const googleConnectorProvider = 'GOOGLE' as const;

export type ContactCenterConnectorProvider = typeof metaConnectorProvider | typeof gupshupConnectorProvider | typeof googleConnectorProvider;

export const nativeDeviceConnectorType = 'WHATSAPP_DEVICE' as const;
export const providerWhatsAppConnectorType = 'PROVIDER_WHATSAPP' as const;
export const facebookMessengerConnectorType = 'FACEBOOK_MESSENGER' as const;
export const facebookCommentsConnectorType = 'FACEBOOK_COMMENTS' as const;
export const instagramConnectorType = 'INSTAGRAM' as const;
export const instagramCommentsConnectorType = 'INSTAGRAM_COMMENTS' as const;
export const tiktokBusinessConnectorType = 'TIKTOK_BUSINESS_MESSAGING' as const;
export const gmailConnectorType = 'GMAIL' as const;
export const telegramConnectorType = 'TELEGRAM' as const;
export const telegramBotConnectionVariant = 'BOT' as const;
export const telegramBusinessConnectionVariant = 'BUSINESS' as const;
export const customWebhookConnectorType = 'CUSTOM_WEBHOOK' as const;

export type TelegramConnectionVariant =
  | typeof telegramBotConnectionVariant
  | typeof telegramBusinessConnectionVariant;

export type ContactCenterConnectorType =
  | typeof nativeDeviceConnectorType
  | typeof providerWhatsAppConnectorType
  | typeof facebookMessengerConnectorType
  | typeof facebookCommentsConnectorType
  | typeof instagramConnectorType
  | typeof instagramCommentsConnectorType
  | typeof tiktokBusinessConnectorType
  | typeof gmailConnectorType
  | typeof telegramConnectorType
  | typeof customWebhookConnectorType;

export const connectorProviderApiBaseUrls: Record<ContactCenterConnectorProvider, string> = {
  [metaConnectorProvider]: '',
  [gupshupConnectorProvider]: 'https://api.gupshup.io',
  [googleConnectorProvider]: '',
};

export const whatsAppDeviceApiBaseUrl = 'https://whatsapi.ada.asia';
